module.exports = __webpack_public_path__ + "static/media/schnell.1e2a5ba4.mp3";